import React, { useState, useEffect } from 'react';
import "./ApplicationStatusChange.scss";
import CTAButton from '../CTAButton/CTAButton';
import Field from '../../Components/Field/Field';
import { applicationStatus, MAIN_CONFIG } from '../../../config/main';
import { CreateOptions } from '../../Utility/SelectListLoader';
import { formatLabelANDValue } from '../../Utility/HelperFunctions';
import Close from '../SVG/Close';
import { handleKeyDown } from '../../Utility/ApplicationFormUtility';



export default function ApplicationStatusChange({ application, handleClose = () => { }, handleUpdateApplicationStatus = () => { } }) {



  const [status, setStatus] = useState(formatLabelANDValue(application.status__c));

  /**
   * Adds the modal content and shows the modal.
   */
  const handleChangeStatus = (option) => {
    setStatus(option)
  }

  return (
    <div className="update-status-page">
      <div className="update-status-page__header">
        <div>
          <h1 className='H1DesktopGreen update-status-title'>Update Status</h1>
        </div>
        <div>
        <button onKeyDown={(e)=>handleKeyDown(e,()=>handleClose())} aria-label='Close Modal' className="event-head H6DesktopGrey close-btn" onClick={handleClose}><Close color={MAIN_CONFIG.COLORS.fillGreen} ariaLabel="Close Modal Button" ariaLabelDescription='' tabIndex={-1}/></button>
        </div>
      </div>
      <div className="update-status-page__content">
        <Field
          className='field-group__field-full'
          type='select'
          label='Update Status'
          options={CreateOptions(applicationStatus)}
          placeholder='Select Update Status'
          value={status ? status : ''}
          handleChange={(val) => handleChangeStatus(val)}
        />
      </div>
      <div className="update-status-page__footer">
        <CTAButton id='status-page__cta__cancel' type='inverse' outline onClick={handleClose}>
            Cancel
        </CTAButton>
        <CTAButton id='status-page__cta' type='tertiary' onClick={() => handleUpdateApplicationStatus(status, application.sfid, application?.scholarship__c||'')}>
          Update
        </CTAButton>
      </div>
    </div>
  )
}